import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import axios from '../../api/axios';

interface ShippingOption {
  shipping_method: string;
  shipping_cost: number;
  fee_service: number;
}

interface DeliveryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (option: string, fee: number, service: number) => void;
  pharmacyName?: string | null;
  pharmacyId?: string | null;
  prescriptionId?: number;
}

const DeliveryModal: React.FC<DeliveryModalProps> = ({
  isOpen,
  onClose,
  onSave,
  pharmacyName,
  pharmacyId,
  prescriptionId,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [shippingOptions, setShippingOptions] = useState<ShippingOption[]>([]);

  const storedData = sessionStorage.getItem('userData');
  const userDataDefault = storedData ? JSON.parse(storedData) : {};
  const userData = userDataDefault;
  const token = userData?.token || '';

  useEffect(() => {
    const fetchShippingOptions = async () => {
      try {
        setIsLoading(true);
        const response = await axios.post(
          `prescriptions/check-ongkir/${prescriptionId}`,
          {
            address_id:
              userData?.person?.address?.[userData.person.address.length - 1]?.id,
            outlet_id: pharmacyId,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = response.data.data;
        setShippingOptions(Object.values(data?.shipping || {}));

      } catch (error) {
        console.error('Error fetching shipping options:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (isOpen && prescriptionId && pharmacyId) {
      fetchShippingOptions();
    }
  }, [isOpen, prescriptionId, pharmacyId]);

  const handleOptionSelect = (option: string, fee: number, service:number ) => {
    onSave(option, fee, service);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-5 w-full max-w-sm shadow-lg relative">
        <button className="absolute top-2 right-2 text-gray-600" onClick={onClose}>
          <FaTimes />
        </button>
        <div className="text-center mb-4">
          <div className="w-10 h-1 bg-gray-300 rounded-full mx-auto mb-2" />
          <h3 className="text-lg font-semibold text-teal-600">Pilihan Pengiriman</h3>
        </div>

        {pharmacyName ? (
          isLoading ? (
            <div className="text-center text-sm text-gray-600">Mohon menunggu...</div>
          ) : shippingOptions.length > 0 ? (
            <div className="space-y-3">
              {shippingOptions.map((option) => (
                <button
                  key={option.shipping_method}
                  className="w-full text-left border rounded p-3 hover:bg-gray-100"
                  onClick={() =>
                    handleOptionSelect(
                      `${option.shipping_method} ${pharmacyName}`,
                      option.shipping_cost,
                      option.fee_service
                    )
                  }
                >
                  <div className="font-semibold">{option.shipping_method}</div>
                  <div className="text-sm text-gray-600">{pharmacyName}</div>
                  <div className="text-right font-bold text-sm">
                    <span>
                      {(
                        option.shipping_cost + option.fee_service
                      ).toLocaleString('id-ID', {
                        style: 'currency',
                        currency: 'IDR',
                        minimumFractionDigits: 0
                      })}
                    </span>
                  </div>
                </button>
              ))}
            </div>
          ) : (
            <div className="text-center text-sm text-gray-600">
              Tidak ada metode pengiriman yang tersedia.
            </div>
          )
        ) : (
          <div className="text-center text-sm text-gray-600">
            Silakan pilih apotek terlebih dahulu untuk melihat opsi pengiriman.
          </div>
        )}
      </div>
    </div>
  );
};

export default DeliveryModal;
